import { render, staticRenderFns } from "./MediaOwnerSelect.vue?vue&type=template&id=0ecfc602&"
import script from "./MediaOwnerSelect.vue?vue&type=script&lang=js&"
export * from "./MediaOwnerSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports